import { Outlet } from "react-router-dom";

import MainWrapper from "../../../../components/layout/MainWrapper";
import { SalesModeProvider } from "../../contexts";

const SalesLayout = () => {
    return (
        <SalesModeProvider>
            <MainWrapper>
                <Outlet />
            </MainWrapper>
        </SalesModeProvider>
    );
};
export default SalesLayout;
